export default __webpack_public_path__ + "static/media/sendgrid.b9049978.svg";